import { type DrawableMixin } from "../objects/drawable_mixin"
import PathObject from "../objects/path"
import Form from "./base"
import PolygonObject from "@/signomatic/app/objects/polygon"
import pathRounding from "@/signomatic/util/path_rounding"
import PolygonPath from "@/signomatic/util/polygon_path"

export default abstract class Polygon extends Form {
  protected path(width: number, height: number, rounding?: number, _curves?: any, forClip?: boolean) {
    const points = this.points(width, height)

    if (!forClip && this.drawables.hasBorder) {
      return new PolygonObject(points, this.defaultParams)
    }

    let path = PolygonPath(points)

    if (rounding) {
      path = pathRounding(path, rounding).join("")
    }

    return new PathObject(path, this.defaultParams)
  }

  protected snappablePaths(width: number, height: number): [DrawableMixin, DrawableMixin] | null {
    if (!["stop", "arrow_left", "arrow_right"].includes(this.state.shape)) {
      return null
    }

    const [side, rest] = this.snappableCommands(width, height)

    return [new PathObject(side.join(""), this.defaultParams), new PathObject(rest.join(""), this.defaultParams)]
  }

  private snappableCommands(width: number, height: number) {
    const points = this.points(width, height)
    const [sideStart, sideEnd] = this.snappableSidePoints()

    const side = [this.pathMoveTo(points[sideStart].x, points[sideStart].y)]
    side.push(this.pathLineToAbs(points[sideEnd].x, points[sideEnd].y))

    const reststart = points[sideEnd]
    const restpoints: Point[] = []

    for (let index = sideEnd; index < points.length; index++) {
      restpoints.push(points[index])
    }

    for (let index = 0; index < sideEnd; index++) {
      restpoints.push(points[index])
    }

    const rest = [this.pathMoveTo(reststart.x, reststart.y)]

    for (const point of restpoints) {
      rest.push(this.pathLineToAbs(point.x, point.y))
    }

    return [side, rest]
  }

  private snappableSidePoints() {
    switch (this.state.shape) {
      case "stop":
        return [3, 4]
      case "arrow_left":
      case "arrow_right":
        return [0, 1]
      default:
        return [0, 1]
    }
  }

  protected cutlinePath(width: number, height: number, rounding?: number) {
    let path = PolygonPath(this.points(width, height))

    if (rounding) {
      path = pathRounding(path, rounding).join("")
    }

    return new PathObject(path, this.defaultParams)
  }

  protected abstract points(width: number, height: number): Point[]
}
